// The newsletter's smooth submit — the footer's signup, wherever the footer is.
//
// Shopify's customer form posts natively: the whole page makes the round trip and re-renders
// with the thank-you line — exactly what the client asked away ("when i put my email, it
// refresh my whole page, it should be smooth"). So the POST goes out as fetch instead, and when
// it lands — Shopify redirects back with customer_posted=true — the field and the button step
// aside for the message the Liquid already keeps in the same form. The page never moves.
//
// One caveat, kept honest: this store protects the form with Shopify's hCaptcha bootstrap, and
// a fetch fired before its token exists is refused (400, "Missing CAPTCHA token" — proved on
// staging, 2026-10-01; the token arrives around the native submission, so it cannot be waited
// for from here — and a hidden iframe cannot read the result, because the storefront sends
// frame-ancestors 'none'). Any refusal, any unexpected response, any network failure therefore
// falls back to the native submit in the open — the round trip this file replaces, with the
// thank-you line it has always rendered (the section now renders that line correctly — its
// check must sit INSIDE the form tag; see footer.liquid). The fetch path simply upgrades the
// sessions that do not need the challenge; nothing gets worse when they do.
(function () {
  var form = document.getElementById('v2-news');
  if (!form) return;
  var email = form.querySelector('input[type="email"]');
  var button = form.querySelector('button[type="submit"]');
  var done = form.querySelector('[data-news-done]');
  if (!email || !button || !done) return;

  form.addEventListener('submit', function (event) {
    if (!email.checkValidity()) return; // the browser's message, not ours
    event.preventDefault();
    button.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form) })
      .then(function (res) {
        if (res.ok && res.url.indexOf('customer_posted=true') !== -1) {
          email.hidden = true;
          button.hidden = true;
          done.hidden = false;
        } else {
          form.submit(); // refused — the native round trip, which has always worked
        }
      })
      .catch(function () { form.submit(); });
  });
})();
